import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteUserSaga,
  getUserDetailSaga,
  getUserListSaga,
} from "src/store/users/saga";
import { UserDetailDto, UserDto } from "src/store/users/type";
import UserCreateForm from "./create";
import UserEditForm from "./edit";
import ChangePassword from "./changePassword";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";

const UsersPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<UserDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [selected, setSelected] = useState<UserDetailDto>();
  const columns = [
    {
      text: t("Users.Name"),
      dataField: "Name",
    },
    {
      text: t("Users.Surname"),
      dataField: "Surname",
    },
    {
      text: t("Users.Email"),
      dataField: "Email",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Users.PageTitle")}
        metaTag={t("Users.MetaTag")}
        gridProps={{
          addTitle: t("Users.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getUserListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getUserDetailSaga({
                  payload: {
                    onSuccess: (m, r) => {
                      setSelected(r);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data) =>
              t("Users.DeleteQA", {
                name: data.Name,
              }),
            action: deleteUserSaga,
            onClick: (id, data) => setShowEdit(data),
          },
          gridButtons(keyValue, data) {
            return (
              <ColumnButton
                buttonType="custom"
                custombutton={{
                  color: "black",
                  text: "Şifre",
                }}
                onClick={() => {
                  setSelected(data);
                  return setShowPassword(true);
                }}
              />
            );
          },
        }}
      />
      <UserCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getUserListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <UserEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getUserListSaga,
              setDataList: setData,
            })
          }
        />
      )}
      {selected && (
        <ChangePassword
          data={selected}
          open={showPassword}
          onHide={() => {
            setShowPassword(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getUserListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default UsersPage;
